/**
 * Admin API Zod Validation Schemas
 */

import { z } from 'zod';

/**
 * User Management Schemas
 */

export const ListUsersSchema = z.object({
  status: z.enum(['active', 'suspended', 'deleted']).optional(),
  role: z.string().optional(),
  searchTerm: z.string().optional(),
  sortBy: z.enum(['createdAt', 'email', 'displayName']).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  limit: z.number().int().min(1).max(100).optional(),
  continuationToken: z.string().optional(),
});

export const UpdateUserStatusSchema = z.object({
  status: z.enum(['active', 'suspended', 'deleted']),
});

export const UpdateUserRolesSchema = z.object({
  roles: z.array(z.enum(['user', 'admin', 'super-admin'])).min(1),
});

export const HardDeleteUserSchema = z.object({
  confirmEmail: z.string().email(),
});

/**
 * Analytics Schemas
 */

export const ListUserUsageStatsSchema = z.object({
  sortBy: z.enum(['totalStorageBytes', 'brandCount', 'dealCount', 'totalDealValue']).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  limit: z.number().int().min(1).max(100).optional(),
  continuationToken: z.string().optional(),
});

export const ListStorageBreakdownSchema = z.object({
  sortBy: z.enum(['totalBytes', 'fileCount']).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  limit: z.number().int().min(1).max(100).optional(),
});

/**
 * Audit Logs Schemas
 */

export const ListAuditLogsSchema = z.object({
  userId: z.string().optional(),
  action: z.string().optional(),
  resourceType: z.string().optional(),
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional(),
  limit: z.number().int().min(1).max(100).optional(),
  continuationToken: z.string().optional(),
});

/**
 * Update User SKU Schema (Super Admin Only)
 */
export const UpdateUserSkuSchema = z.object({
  skuId: z.string().min(1),
  reason: z.string().min(1).max(500).optional(),
});
